<template>
    <div>
        <v-text-field v-if="isNewSelected"
                      :label="label" v-model="searchText" @click:clear="onClear()"
                      readonly clearable :success-messages="[newMessage]">
        </v-text-field>

        <v-autocomplete v-else :label="label"
                        v-model="selection" @input="onSelectionUpdated"
                        :items="items" :item-text="itemText" v-bind="$attrs"
                        clearable :search-input.sync="searchText" ref="autocomplete">
            <template #no-data>
                <v-container>
                    {{$vopsui.labels.combobox.valueDoesNotExist(searchText)}}
                </v-container>
            </template>
            <template #item="props" v-if="$scopedSlots.item">
                <slot name="item" v-bind="props"/>
            </template>
            <template #append-item>
                <v-btn text color="primary" @click="onCreate()" v-if="showCreate">
                    {{$vopsui.labels.combobox.createValueQuotes(searchText)}}
                </v-btn>
            </template>
        </v-autocomplete>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop, Emit, Watch} from "vue-property-decorator";

    @Component
    export default class Combobox extends Vue {
        @Prop() label: string;
        @Prop() items: any[];
        @Prop() value: any;
        @Prop({default: 'text'}) itemText: string;
        @Prop({type: Boolean, default: false}) allowDuplicates: boolean;

        @Emit() input(value: any) {
            return value;
        }

        @Emit() create(text: string) {
            return text;
        }

        @Emit() onSearch(searchText: string) {
        }

        selection: any = null;
        searchText: string = null;
        isNewSelected: boolean = false;

        get showCreate() {
            return this.searchText != null && this.searchText !== '' &&
                (this.allowDuplicates || !this.items.find(x => this.isMatchingSearchText(x)));
        }

        get newMessage() {
            return this.$vopsui.labels.combobox.valueWillBeCreated(this.searchText);
        }

        @Watch('value', {immediate: true})
        onValueUpdated() {
            this.selection = this.value;
        }

		@Watch("searchText")
		onSearchTextChanged() {
			this.onSearch(this.searchText);
		}

        onSelectionUpdated(value: any) {
            this.input(value);
        }

        onCreate() {
            this.isNewSelected = true;
            this.input(null);
            this.create(this.searchText);
        }

        async onClear() {
            this.selection = null;
            this.isNewSelected = false;
            this.input(null);
            this.create(null);

            await this.$nextTick();
            const autocomplete = this.$refs.autocomplete as HTMLInputElement;
            autocomplete.focus();
        }

        private isMatchingSearchText(x: any) {
            const itemText: string = (typeof x === 'string') ? x : x[this.itemText];
            return this.searchText.toLocaleLowerCase() === itemText.toLocaleLowerCase();
        }
    }
</script>